import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export function SortableItem(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: props.id
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <MyItem id={props.id} />
        </div>
    );
}

export function MyItem(props) {

    const { id } = props;

    const style = {
        color: id.col || "deeppink",
        border: "1px solid grey",
        padding: "0.2em",
        width: "12em",
        cursor: "move"
    };

    return (
        <li style={style}>{id.bahnhof}</li>
    )
}